import { ChevronRight } from "lucide-react";
import NextImage from "next/image";
import whatsappIcon from "@/public/icons/whatsapp.svg";

export const DiscordButtonIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2.375rem"
    height="1.75rem"
    viewBox="0 0 19 14"
    fill="none"
    style={{ width: "2.375rem", height: "1.75rem", flexShrink: 0 }}
  >
    <path
      d="M12.1747 0C11.989 0.32044 11.8223 0.651933 11.6707 0.990792C10.2308 0.78085 8.76444 0.78085 7.32077 0.990792C7.173 0.651933 7.00248 0.32044 6.81682 0C5.46409 0.224685 4.14545 0.618785 2.89504 1.17495C0.416926 4.74402 -0.253754 8.22099 0.0796955 11.6501C1.53094 12.6924 3.15649 13.488 4.88813 13.9963C5.27841 13.488 5.62323 12.9466 5.91879 12.3831C5.35799 12.1805 4.81613 11.9263 4.29703 11.6317C4.43343 11.5359 4.56605 11.4365 4.69488 11.3407C7.73758 12.733 11.2615 12.733 14.308 11.3407C14.4368 11.4438 14.5694 11.5433 14.7058 11.6317C14.1867 11.93 13.6449 12.1805 13.0803 12.3867C13.3758 12.9503 13.7206 13.4917 14.1109 14C15.8425 13.4917 17.4681 12.6998 18.9194 11.6575C19.3134 7.67955 18.2449 4.23204 16.0964 1.17864C14.8498 0.622475 13.5312 0.22836 12.1785 0.00736458L12.1747 0ZM6.34317 9.5396C5.40726 9.5396 4.63048 8.71455 4.63048 7.6943C4.63048 6.67405 5.37694 5.84531 6.33939 5.84531C7.30184 5.84531 8.06723 6.67772 8.05208 7.6943C8.03693 8.71087 7.29804 9.5396 6.34317 9.5396ZM12.6559 9.5396C11.7162 9.5396 10.947 8.71455 10.947 7.6943C10.947 6.67405 11.6935 5.84531 12.6559 5.84531C13.6184 5.84531 14.38 6.67772 14.3648 7.6943C14.3497 8.71087 13.6108 9.5396 12.6559 9.5396Z"
      fill="#5C6AF3"
    />
  </svg>
);

export const iconMap = {
  none: null,
  discord: <DiscordButtonIcon />,
  arrowRight: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="24"
        height="24"
        fill="white"
        fillOpacity="0.01"
        style={{ mixBlendMode: "multiply" }}
      />
      <path
        d="M13.5 4.5L12.4275 5.54475L18.1125 11.25H3V12.75H18.1125L12.4275 18.4298L13.5 19.5L21 12L13.5 4.5Z"
        fill="#161616"
      />
    </svg>
  ),
  whatsapp: (
    <NextImage
      src={whatsappIcon}
      alt=""
      unoptimized
      className="h-[3.5rem] w-[3.5rem] shrink-0 object-contain"
    />
  ),
  document: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="white" fillOpacity="0.01" />
      <path
        d="M22.5 18.75L21.4395 17.6895L19.5 19.629V13.5H18V19.629L16.0605 17.6895L15 18.75L18.75 22.5L22.5 18.75Z"
        fill="white"
      />
      <path
        d="M13.5 21H6V3.00001H12V7.50001C12.0011 7.89749 12.1596 8.27835 12.4406 8.55941C12.7217 8.84046 13.1025 8.99887 13.5 9.00001H18V11.25H19.5V7.50001C19.5027 7.40144 19.484 7.30346 19.4451 7.21282C19.4063 7.12218 19.3482 7.04105 19.275 6.97501L14.025 1.72501C13.959 1.65176 13.8778 1.59371 13.7872 1.55486C13.6966 1.51601 13.5986 1.4973 13.5 1.50001H6C5.60253 1.50116 5.22166 1.65957 4.94061 1.94062C4.65955 2.22168 4.50115 2.60254 4.5 3.00001V21C4.50115 21.3975 4.65955 21.7783 4.94061 22.0594C5.22166 22.3405 5.60253 22.4989 6 22.5H13.5V21ZM13.5 3.30001L17.7 7.50001H13.5V3.30001Z"
        fill="white"
      />
    </svg>
  ),
};
